import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const RedosNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="redos" />;
};
